import { gql } from "@apollo/client";

export const saveRemoteApiSpec = gql`
    mutation saveRemoteApiSpec(
        $id: ID
        $name: String!
        $iconUrl: String!
        $providerName: String!
        $description: String!
        $documentationUrl: String!
        $visibility: SpecVisibility!
        $host: String!
        $endpoints: [RemoteApiHttpEndpointInput!]!
        $maxRequestSizeBytes: Int!
        $maxResponseSizeBytes: Int!
        $maxResponseTimeMillis: Int!
        $snapkitAppId: String!
        $targetPlatforms: [TargetPlatform!]!
        $localOnly: Boolean!
        $minLensStudioVersion: String!
        $useBuiltinLocalProcessor: Boolean!
        $orgId: ID!
        $customVisibilityUsersList: [String!]!
    ) {
        saveRemoteApiSpec(
            input: {
                id: $id
                name: $name
                iconUrl: $iconUrl
                providerName: $providerName
                description: $description
                documentationUrl: $documentationUrl
                visibility: $visibility
                host: $host
                endpoints: $endpoints
                maxRequestSizeBytes: $maxRequestSizeBytes
                maxResponseSizeBytes: $maxResponseSizeBytes
                maxResponseTimeMillis: $maxResponseTimeMillis
                snapkitAppId: $snapkitAppId
                targetPlatforms: $targetPlatforms
                localOnly: $localOnly
                minLensStudioVersion: $minLensStudioVersion
                useBuiltinLocalProcessor: $useBuiltinLocalProcessor
                orgId: $orgId
                customVisibilityUsersList: $customVisibilityUsersList
            }
        ) {
            id
        }
    }
`;
